import _ from 'lodash';

export const preparePaymentMonthData = (months) => {
  const newData = [];

  if (!months || !Array.isArray(months)) {
    return [];
  }

  for (const payment of months) {
    const paymentDate = new Date(payment.paymentDate);
    const paymentYear = paymentDate.getFullYear();

    const prepareData = {
      title: payment.label,
      disabled: payment.confirmed,
      value: payment.value,
    };

    const existingPayment = newData.find((item) => item.title === paymentYear);

    if (!existingPayment) {
      newData.push({
        title: paymentYear,
        disabled: true,
        value: paymentYear.toString(),
        children: [prepareData],
      });
    } else {
      existingPayment.children.push(prepareData);
    }
  }

  return newData;
};
